import React from "react";
import PropTypes from "prop-types";

import styles from "./styles.css";
import Checkbox from "../../../shared/checkbox/component";
import getAppliedFilter from "../../../../utils/filters-v2/get-applied-filter";
import { GA_EVENTS } from "../../car-listing/tracking";
import { trackDesktopCustomEventsAU } from "../../../../tracking";
import { yieldToMain } from "../../../../utils/helpers/yield-to-main";

const GreatDeals = ({appliedFilters, filter, onOptionSelection}) => {

    const { options = [], key: filterKey } = filter;

    const selectOption = async (optionKey, isSelected, displayText) => {
        await yieldToMain();
        const eventLabel = `${optionKey} ${isSelected ? "ON" : "OFF"}`;
        onOptionSelection({ filterKey, optionKey, isSelected, displayText}, eventLabel);
        if (isSelected) {
            trackDesktopCustomEventsAU(GA_EVENTS.FILTER_SELECTED, {
                ...GA_EVENTS.FILTER_SELECTED,
                eventLabel: "GREAT DEALS"
            });
            trackDesktopCustomEventsAU(GA_EVENTS.FILTER_GREAT_DEALS, {
                ...GA_EVENTS.FILTER_GREAT_DEALS,
                eventLabel: displayText
            });
        }

    };

    return (
        <div styleName={"styles.bodyTypeOuter"}>
            {options.map((option) => {
                const isSelected = !!getAppliedFilter({filterKey, optionKey: option.key}, appliedFilters);
                return (
                    <div styleName={"styles.popularMakeWrapper"} key={option.key}>
                        <div styleName={"styles.checkBoxContainer"}>
                            <Checkbox checkedStatus={isSelected} onChange={selectOption.bind(null, option.key, !isSelected, option.displayText)} id={option.name}/>
                            <p styleName={"styles.featureName"}>{option.displayName}</p>
                        </div>
                        <p styleName={"styles.featureCount"}>{option.count}</p>
                    </div>
                );
            })
            }
        </div>
    );
};

GreatDeals.propTypes = {
    appliedFilters: PropTypes.array,
    filter: PropTypes.object,
    onOptionSelection: PropTypes.func
};

export default GreatDeals;
